import React from 'react';
import { bool, node } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';
import { Form, PrimaryButton, FieldTextInput } from '../../../components';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import FieldPhoneNumberInternationalInput from '../../../components/FieldPhoneNumberInternationalInput/FieldPhoneNumberInternationalInput';



import css from './SignupForm.module.css';

const SignupFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        invalid,
        intl,
        termsAndConditions,
      } = fieldRenderProps;

      // email
      const emailRequired = validators.required(
        intl.formatMessage({
          id: 'SignupForm.emailRequired',
        })
      );
      const emailValid = validators.emailFormatValid(
        intl.formatMessage({
          id: 'SignupForm.emailInvalid',
        })
      );

      // password
      const passwordRequiredMessage = intl.formatMessage({
        id: 'SignupForm.passwordRequired',
      });
      const passwordMinLengthMessage = intl.formatMessage(
        {
          id: 'SignupForm.passwordTooShort',
        },
        {
          minLength: validators.PASSWORD_MIN_LENGTH,
        }
      );
      const passwordMaxLengthMessage = intl.formatMessage(
        {
          id: 'SignupForm.passwordTooLong',
        },
        {
          maxLength: validators.PASSWORD_MAX_LENGTH,
        }
      );
      const passwordMinLength = validators.minLength(
        passwordMinLengthMessage,
        validators.PASSWORD_MIN_LENGTH
      );
      const passwordMaxLength = validators.maxLength(
        passwordMaxLengthMessage,
        validators.PASSWORD_MAX_LENGTH
      );
      const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);
      const passwordValidators = validators.composeValidators(
        passwordRequired,
        passwordMinLength,
        passwordMaxLength
      );


      const phoneNumberRequired = validators.required(
        intl.formatMessage({
          id: 'SignupForm.phoneNumberRequired',
        })
      );

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress;

      const [verificationMethod, setVerificationMethod] = React.useState('sms');

      const handleChange = (event, value) => {
        setVerificationMethod(value);
        // set the form value
        fieldRenderProps.form.change('verificationMethod', value);
        //form.verificationMethod = value;
      };

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div>


            <FieldTextInput
              type="hidden"
              id={formId ? `${formId}.verificationMethod` : 'verificationMethod'}
              name="verificationMethod"
              autoComplete="verificationMethod"
            />


            <FieldTextInput
              type="email"
              id={formId ? `${formId}.email` : 'email'}
              name="email"
              autoComplete="email"
              label={intl.formatMessage({
                id: 'SignupForm.emailLabel',
              })}
              placeholder={intl.formatMessage({
                id: 'SignupForm.emailPlaceholder',
              })}
              validate={validators.composeValidators(emailRequired, emailValid)}
            />
            <div className={css.name}>
              <FieldTextInput
                className={css.firstNameRoot}
                type="text"
                id={formId ? `${formId}.fname` : 'fname'}
                name="fname"
                autoComplete="given-name"
                label={intl.formatMessage({
                  id: 'SignupForm.firstNameLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'SignupForm.firstNamePlaceholder',
                })}
                validate={validators.required(
                  intl.formatMessage({
                    id: 'SignupForm.firstNameRequired',
                  })
                )}
              />
              <FieldTextInput
                className={css.lastNameRoot}
                type="text"
                id={formId ? `${formId}.lname` : 'lname'}
                name="lname"
                autoComplete="family-name"
                label={intl.formatMessage({
                  id: 'SignupForm.lastNameLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'SignupForm.lastNamePlaceholder',
                })}
                validate={validators.required(
                  intl.formatMessage({
                    id: 'SignupForm.lastNameRequired',
                  })
                )}
              />
            </div>
            <FieldTextInput
              className={css.password}
              type="password"
              id={formId ? `${formId}.password` : 'password'}
              name="password"
              autoComplete="new-password"
              label={intl.formatMessage({
                id: 'SignupForm.passwordLabel',
              })}
              placeholder={intl.formatMessage({
                id: 'SignupForm.passwordPlaceholder',
              })}
              validate={passwordValidators}
            />






            <div style={{
              marginTop: '10px',
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            }}>

              <FieldPhoneNumberInternationalInput

                id="phoneNumber"
                name="phoneNumber"
                defaultCountry="US"
                className={css.title}
                withCountryCallingCode
                countryCallingCodeEditable={false}
                international
                label={intl.formatMessage({
                  id: 'SignupForm.phoneNumberLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'SignupForm.phoneNumberPlaceholder',
                })}
                validate={phoneNumberRequired}
              />

              {/* <FieldTextInput              
                  type="phoneNumber"
                  id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
                  name="phoneNumber"
                  autoComplete="phoneNumber"
                  label={intl.formatMessage({
                    id: 'SignupForm.phoneNumberLabel',
                  })}
                  placeholder={intl.formatMessage({
                    id: 'SignupForm.phoneNumberPlaceholder',
                  })}
                  validate={phoneNumberRequired}
                /> */}

              <label style={{ marginTop: 32 }}>
                {intl.formatMessage({ id: 'SignupForm.verificationMethodLabel' })}
              </label>
              <ToggleButtonGroup size="small"
                exclusive
                aria-label="Verification Method"
                onChange={handleChange}
                id={formId ? `${formId}.verificationMethod` : 'verificationMethod'}
                value={verificationMethod}
                style={{ marginLeft: '0' }}
                label="Verification Method"
              >
                <ToggleButton value="sms" key="sms">
                  SMS
                </ToggleButton>
                <ToggleButton value="call" key="call">
                  Call
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
             <div className={css.smsDisclaimer}>
              <p style={{ 
                fontSize: '12px', 
                color: '#666', 
                lineHeight: '1.4',
                margin: '12px 0 8px 0',
                fontFamily: 'inherit'
              }}>
                By submitting this form and entering your phone number above, you agree to receive automated text messages from Setcircle. Consent is not a condition of any purchase. Msg frequency varies. Msg and data rates may apply. Reply HELP for help and STOP to cancel.
              </p>
            </div>

          </div>

          <div className={css.bottomWrapper}>
           
            {termsAndConditions}
            <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
              <FormattedMessage id="SignupForm.signUp" />
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

SignupFormComponent.defaultProps = { inProgress: false };

SignupFormComponent.propTypes = {
  inProgress: bool,
  termsAndConditions: node.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SignupForm = compose(injectIntl)(SignupFormComponent);
SignupForm.displayName = 'SignupForm';

export default SignupForm;
